import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Box, AppBar, Toolbar, Typography, Tabs, Tab, IconButton } from "@mui/material"
import { Dashboard, People, LocationOn, Timeline, Logout } from "@mui/icons-material"
import { useAuth } from "../contexts/AuthContext"

const AdminLayout = ({ children }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { logout, currentUser } = useAuth()

  const handleLogout = async () => {
    try {
      await logout()
      navigate("/admin/login")
    } catch (error) {
      console.error("Logout failed:", error)
    }
  }

  const getTabValue = () => {
    if (location.pathname === "/admin/dashboard") return 0
    if (location.pathname === "/admin/users") return 1
    if (location.pathname === "/admin/bathrooms") return 2
    if (location.pathname === "/admin/activity") return 3
    return 0
  }

  const handleTabChange = (event, newValue) => {
    const routes = ["/admin/dashboard", "/admin/users", "/admin/bathrooms", "/admin/activity"]
    navigate(routes[newValue])
  }

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      {/* Admin AppBar */}
      <AppBar position="static" elevation={0} sx={{ background: "linear-gradient(45deg, #4A00E0 30%, #8E2DE2 90%)" }}>
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: "bold" }}>
            🔒 Admin Panel
          </Typography>
          <Typography variant="body2" sx={{ mr: 2, opacity: 0.9 }}>
            {currentUser?.email}
          </Typography>
          <IconButton color="inherit" onClick={handleLogout} title="Logout">
            <Logout />
          </IconButton>
        </Toolbar>
        <Tabs value={getTabValue()} onChange={handleTabChange} textColor="inherit" indicatorColor="secondary" sx={{ bgcolor: "rgba(0,0,0,0.1)" }}>
          <Tab icon={<Dashboard />} label="Dashboard" iconPosition="start" />
          <Tab icon={<People />} label="Users" iconPosition="start" />
          <Tab icon={<LocationOn />} label="Bathrooms" iconPosition="start" />
          <Tab icon={<Timeline />} label="Activity" iconPosition="start" />
        </Tabs>
      </AppBar>

      {/* Content */}
      <Box>{children}</Box>
    </Box>
  )
}

export default AdminLayout
